const experienceTimeline = [
  {
    title: "IT Business Analysis",
    highlighted: "TBC Bank",
    desc: " — Analyzing business needs, documenting requirements, mapping processes, and bridging communication between stakeholders and technical teams.",
    date: "Apr 2025 - Present",
  },
  {
    title: "Associate Member",
    highlighted: "Georgian AI Association",
    desc: " — Promoting AI education and adoption in Georgia. Actively sharing knowledge and supporting community initiatives to help grow the local tech ecosystem.",
    date: "Dec 2025 - Present",
  },
  {
    title: "Test Automation Trainee",
    highlighted: "TBC Bank",
    desc: " — Built Java automation scripts for functional and API testing. Streamlined testing workflows using Selenium, TestNG, and REST Assured.",
    date: "Jun 2025 - Nov 2025",
  },
  {
    title: "Python Intern",
    highlighted: "UniLab",
    desc: " — Created Python scripts for data processing and API integration. Worked on workflow automation and optimization using Flask, Docker, and databases.",
    date: "May 2025 - Sep 2025",
  },
  {
    title: "AI & Data Science Club Member",
    highlighted: "Georgian AI Association",
    desc: " — Collaborated in AI/ML workshops and hackathons. Applied Python, Pandas, and Scikit-Learn for data modeling and feature engineering.",
    date: "Apr 2025 - Jul 2025",
  },
];

export default experienceTimeline;
